import barIcon from "assets/icons/integrationPage/bar-icon.png";
import intergationIcon from "assets/icons/integrationPage/integration-icon.png";
import instructionIcon from "assets/icons/integrationPage/instruction-icon.png";
import gamesIcon from "assets/icons/integrationPage/games-icon.png";
import setIcon from "assets/icons/integrationPage/set-icon.png";

import personImage from "assets/icons/integrationPage/person-image.png";
import drinkImage from "assets/icons/integrationPage/drink-image.png";
import presentImage from "assets/icons/integrationPage/present-image.png";
import socksImage from "assets/icons/integrationPage/socks-image.png";
import tshirtImage from "assets/icons/integrationPage/tshirt-image.png";

import i18n from "i18n";

const features = {
  integration: () => ({
    img: intergationIcon,
    content: `${i18n.t(`integrationPage.features.integration`)}`,
  }),
  instruction: () => ({
    img: instructionIcon,
    content: `${i18n.t(`integrationPage.features.instruction`)}`,
  }),
  set: () => ({
    img: setIcon,
    content: `${i18n.t(`integrationPage.features.set`)}`,
  }),
  games: () => ({
    img: gamesIcon,
    content: `${i18n.t(`integrationPage.features.games`)}`,
  }),
  bar: () => ({
    img: barIcon,
    content: `${i18n.t(`integrationPage.features.bar`)}`,
  }),
};

const additionals = () => {
  return [
    {
      img: personImage,
      content: i18n.t("integrationPage.additionals.participant"),
      hidden: i18n.t("integrationPage.additionals.participantHidden"),
    },
    {
      img: drinkImage,
      content: i18n.t("integrationPage.additionals.drink"),
      hidden: i18n.t("integrationPage.additionals.drinkHidden"),
    },
    {
      img: tshirtImage,
      content: i18n.t("integrationPage.additionals.tshirt"),
      hidden: i18n.t("integrationPage.additionals.tshirtHidden"),
    },
    {
      img: socksImage,
      content: i18n.t("integrationPage.additionals.socks"),
      hidden: i18n.t("integrationPage.additionals.socksHidden"),
    },
    {
      img: presentImage,
      content: i18n.t("integrationPage.additionals.starter"),
      hidden: i18n.t("integrationPage.additionals.starterHidden"),
    },
  ];
};
const getFeatures = (featuresList = []) => {
  return featuresList.map((featureName) => {
    return features[featureName]();
  });
};

export const getIntegrationConfig = () => {
  return {
    wroclaw: {
      backgroundVideoID: "8LVcqjxw2iA",
      mobileBackgroundVideoID: "3ugdcBfUxb8",
      doesCityHavePackages: true,
      packages: [
        {
          name: i18n.t("integrationPage.packages.packageL"),
          price: "84 PLN",
          boards: i18n.t("integrationPage.packages.oneBoard"),
          players: "6-10",
        },
        {
          name: i18n.t("integrationPage.packages.packageL+"),
          price: "79 PLN",
          boards: i18n.t("integrationPage.packages.oneBoardAndArena"),
          players: "11-16",
        },
        {
          name: i18n.t("integrationPage.packages.packageXL"),
          price: "74 PLN",
          boards: i18n.t("integrationPage.packages.twoBoards"),
          players: "17-20",
        },
        {
          name: i18n.t("integrationPage.packages.packageXL+"),
          price: "72 PLN",
          boards: i18n.t("integrationPage.packages.twoBoardsAndArena"),
          players: "21-28",
        },
        {
          name: i18n.t("integrationPage.packages.packageXXL"),
          price: "69 PLN",
          boards: i18n.t("integrationPage.packages.wholeVenue"),
          players: "29-48",
        },
      ],
      images: [
        {
          title: "First integration image",
          src: "/images/integrationPage/integration-1.jpg",
          alt: "First integration image",
        },
        {
          title: "Second integration image",
          src: "/images/integrationPage/integration-2.jpg",
          alt: "Second integration image",
        },
        {
          title: "Third integration image",
          src: "/images/integrationPage/integration-3.jpg",
          alt: "Third integration image",
        },
        {
          title: "Fourth integration image",
          src: "/images/integrationPage/integration-4.jpg",
          alt: "Fourth integration image",
        },
        {
          title: "Fifth integration image",
          src: "/images/integrationPage/integration-5.jpg",
          alt: "Fifth integration image",
        },
        {
          title: "Sixth integration image",
          src: "/images/integrationPage/integration-6.jpg",
          alt: "Sixth integration image",
        },
      ],
      additionals: additionals(),
      features: getFeatures([
        "integration",
        "instruction",
        "set",
        "games",
        "bar",
      ]),
    },

    katowice: {
      backgroundVideoID: "8LVcqjxw2iA",
      mobileBackgroundVideoID: "3ugdcBfUxb8",
      doesCityHavePackages: true,
      packages: [
        {
          name: i18n.t("integrationPage.packages.packageL"),
          price: "92 PLN",
          boards: i18n.t("integrationPage.packages.oneBoard"),
          players: "6-10",
        },
        {
          name: i18n.t("integrationPage.packages.packageL+"),
          price: "89 PLN",
          boards: i18n.t("integrationPage.packages.twoBoards"),
          players: "11-18",
        },
        {
          name: i18n.t("integrationPage.packages.packageXL"),
          price: "84 PLN",
          boards: i18n.t("integrationPage.packages.threeBoards"),
          players: "19-28",
        },
        {
          name: i18n.t("integrationPage.packages.packageXL+"),
          price: "79 PLN",
          boards: i18n.t("integrationPage.packages.fourBoards"),
          players: "29-36",
        },
      ],
      extraPackage: true,
      images: [
        {
          title: "First integration image",
          src: "/images/integrationPage/integration-1.jpg",
          alt: "First integration image",
        },
        {
          title: "Second integration image",
          src: "/images/integrationPage/integration-2.jpg",
          alt: "Second integration image",
        },
        {
          title: "Third integration image",
          src: "/images/integrationPage/integration-3.jpg",
          alt: "Third integration image",
        },
        {
          title: "Fourth integration image",
          src: "/images/integrationPage/integration-4.jpg",
          alt: "Fourth integration image",
        },
        {
          title: "Fifth integration image",
          src: "/images/integrationPage/integration-5.jpg",
          alt: "Fifth integration image",
        },
        {
          title: "Sixth integration image",
          src: "/images/integrationPage/integration-6.jpg",
          alt: "Sixth integration image",
        },
      ],
      additionals: additionals(),
      features: getFeatures([
        "integration",
        "instruction",
        "set",
        "games",
        "bar",
      ]),
    },
    gdansk: {
      backgroundVideoID: "8LVcqjxw2iA",
      mobileBackgroundVideoID: "3ugdcBfUxb8",

      doesCityHavePackages: true,
      packages: [
        {
          name: i18n.t("integrationPage.packages.packageL"),
          price: "92 PLN",
          boards: i18n.t("integrationPage.packages.oneBoard"),
          players: "6-10",
        },
        {
          name: i18n.t("integrationPage.packages.packageL+"),
          price: "89 PLN",
          boards: i18n.t("integrationPage.packages.twoBoards"),
          players: "11-18",
        },
        {
          name: i18n.t("integrationPage.packages.packageXL"),
          price: "84 PLN",
          boards: i18n.t("integrationPage.packages.threeBoards"),
          players: "19-28",
        },
        {
          name: i18n.t("integrationPage.packages.packageXL+"),
          price: "79 PLN",
          boards: i18n.t("integrationPage.packages.fourBoards"),
          players: "29-36",
        },
      ],
      extraPackage: true,
      images: [
        {
          title: "First integration image",
          src: "/images/integrationPage/integration-1.jpg",
          alt: "First integration image",
        },
        {
          title: "Second integration image",
          src: "/images/integrationPage/integration-2.jpg",
          alt: "Second integration image",
        },
        {
          title: "Third integration image",
          src: "/images/integrationPage/integration-3.jpg",
          alt: "Third integration image",
        },
        {
          title: "Fourth integration image",
          src: "/images/integrationPage/integration-4.jpg",
          alt: "Fourth integration image",
        },
        {
          title: "Fifth integration image",
          src: "/images/integrationPage/integration-5.jpg",
          alt: "Fifth integration image",
        },
        {
          title: "Sixth integration image",
          src: "/images/integrationPage/integration-6.jpg",
          alt: "Sixth integration image",
        },
      ],
      additionals: additionals(),
      features: getFeatures([
        "integration",
        "instruction",
        "set",
        "games",
        "bar",
      ]),
    },
    poznan: {
      backgroundVideoID: "8LVcqjxw2iA",
      mobileBackgroundVideoID: "3ugdcBfUxb8",
      doesCityHavePackages: true,
      packages: [
        {
          name: i18n.t("integrationPage.packages.packageL"),
          price: "92 PLN",
          boards: i18n.t("integrationPage.packages.oneBoard"),
          players: "6-10",
        },
        {
          name: i18n.t("integrationPage.packages.packageL+"),
          price: "89 PLN",
          boards: i18n.t("integrationPage.packages.twoBoards"),
          players: "11-18",
        },
        {
          name: i18n.t("integrationPage.packages.packageXL"),
          price: "84 PLN",
          boards: i18n.t("integrationPage.packages.threeBoards"),
          players: "19-28",
        },
        {
          name: i18n.t("integrationPage.packages.packageXL+"),
          price: "79 PLN",
          boards: i18n.t("integrationPage.packages.fourBoards"),
          players: "29-36",
        },
      ],
      extraPackage: true,
      images: [
        {
          title: "First integration image",
          src: "/images/integrationPage/integration-1.jpg",
          alt: "First integration image",
        },
        {
          title: "Second integration image",
          src: "/images/integrationPage/integration-2.jpg",
          alt: "Second integration image",
        },
        {
          title: "Third integration image",
          src: "/images/integrationPage/integration-3.jpg",
          alt: "Third integration image",
        },
        {
          title: "Fourth integration image",
          src: "/images/integrationPage/integration-4.jpg",
          alt: "Fourth integration image",
        },
        {
          title: "Fifth integration image",
          src: "/images/integrationPage/integration-5.jpg",
          alt: "Fifth integration image",
        },
        {
          title: "Sixth integration image",
          src: "/images/integrationPage/integration-6.jpg",
          alt: "Sixth integration image",
        },
      ],
      additionals: additionals(),
      features: getFeatures([
        "integration",
        "instruction",
        "set",
        "games",
        "bar",
      ]),
    },
  };
};
